import { isIOS } from "../common/device";
import { PUBLIC_URL_ROOT } from "./secrets"; // this import is needed to set the window properties in dev mode

const langToFont: any = {
  en: {
    normal: `${PUBLIC_URL_ROOT}assets/fonts/rubik/normal.ttf`,
    bold: `${PUBLIC_URL_ROOT}assets/fonts/rubik/bold.ttf`,
  },
  es: {
    normal: `${PUBLIC_URL_ROOT}assets/fonts/rubik/normal.ttf`,
    bold: `${PUBLIC_URL_ROOT}assets/fonts/rubik/bold.ttf`,
  },
  zh: {
    normal: `${PUBLIC_URL_ROOT}assets/fonts/noto_sans/chinese/normal.ttf`,
    bold: `${PUBLIC_URL_ROOT}assets/fonts/noto_sans/chinese/bold.ttf`,
  },
  ar: {
    normal: `${PUBLIC_URL_ROOT}assets/fonts/frutiger-lt/normal.ttf`,
    bold: `${PUBLIC_URL_ROOT}assets/fonts/frutiger-lt/bold.ttf`,
  },
};

if (isIOS()) {
  langToFont["en"] = {
    ...langToFont["en"],
    normal: `${PUBLIC_URL_ROOT}assets/fonts/roboto/roboto.medium.ttf`,
    bold: `${PUBLIC_URL_ROOT}assets/fonts/roboto/roboto.bold.ttf`,
  };
}

let lang = (window as any).LOCALE || "/en";
lang = lang.replace("/", "");

export const textDirection = lang === "ar" ? "rtl" : "ltr";
export const textAlignLeft = lang === "ar" ? "right" : "left";
export const textAlignCenter = lang === "ar" ? "right" : "center";

export const fontFamilyNormal = langToFont[lang].normal;
export const fontFamilyBold = langToFont[lang].bold;
